import { Box, TextField, Typography } from '@mui/material'
import { useController } from 'react-hook-form'
import { RenderTooltip } from '../../../utilities/RenderTooltip'
import styles from './RiskRangeNumberInputForm.module.scss'
import SelectInputForm from '../SelectInputForm/SelectInputForm'
import { useTranslation } from 'react-i18next'
import { update } from 'react-querybuilder'
import toaster from '../../../../toaster'

const RiskRangeNumberInputForm = ({ range, rangesName, control, label, required, tooltip, errors }) => {
  const { t } = useTranslation(['common'])

  const fieldError = errors?.[rangesName]?.[range]?.max?.message

  const options = [
    { value: '', label: `${t('common:NONE')}` },
    { value: 'APPROVED', label: t('common:APPROVED') },
    { value: 'DENIED', label: t('common:DENIED') },
    { value: 'IN_PROGRESS', label: t('common:IN_PROGRESS') },
    { value: 'NOT_STARTED', label: t('common:NOT_STARTED') },
    { value: 'PROCESSED', label: t('common:PROCESSED') },
  ]

  const {
    field: { value: ranges, onChange: onChangeRanges },
  } = useController({
    name: rangesName,
    control,
  })

  const riskOrder = ['low', 'medium', 'high', 'veryHigh']

  const onMaxChange = (newValue) => {
    const updatedRanges = { ...ranges }
    const currentIndex = riskOrder.indexOf(range)

    updatedRanges[range].max = newValue

    if (newValue === '') {
      toaster.error(`${t(`messages:fieldCannotBeEmpty`)}`)
    }

    updatedRanges[range].max = newValue === '' ? undefined : Number(newValue)

    const nextKey = riskOrder[currentIndex + 1]
    if (nextKey && newValue !== '') {
      updatedRanges[nextKey].min = Math.round((Number(newValue) + 0.01) * 100) / 100
    }

    if (range === 'low') {
      updatedRanges.low.min = 0
    }

    onChangeRanges(updatedRanges)
  }

  const onActionChange = (value) => {
    let updatedRanges = { ...ranges }
    updatedRanges[range].action = value
    onChangeRanges(updatedRanges)
  }

  return (
    <Box className={styles.container}>
      <Box className={styles.label}>
        {!!label && <Typography variant="subtitle2">{label}</Typography>}
        {!!label && !!required && <Typography variant="subtitle3">(*)</Typography>}
        {!!tooltip && <RenderTooltip title={tooltip} />}
      </Box>
      <Box className={styles.items}>
        <TextField
          fullWidth
          type="number"
          value={ranges[range]?.max ?? ''}
          onChange={(e) => onMaxChange(e.target.value)}
          inputProps={{
            step: 0.1,
            style: { textAlign: fieldError ? 'left' : 'right' },
          }}
          error={!!fieldError}
          placeholder={fieldError || ''}
          sx={{
            ...(fieldError && {
              '& input::placeholder': {
                color: 'red',
                opacity: 1,
              },
            }),
          }}
        />
        <SelectInputForm
          options={options}
          control={control}
          name={`${rangesName}.${range}.action`}
          onChange={(e) => onActionChange(e.target.value)}
          emptyLabel={`${t('common:select')} ${t('common:status')}`}
          defaultValue=""
        />
      </Box>
    </Box>
  )
}

export default RiskRangeNumberInputForm
